// extracted by mini-css-extract-plugin
export default {"color":"SideNavForMap_color__IIihl","sideNavForMap":"SideNavForMap_sideNavForMap__kO1HW"};